import React from "react";
import {IRouteListItem} from "../../../service/Index";
import styles from "../../../styles/index";
import "./index.less";


import ClubActivitySportItem from "../../../components/Index/ClubActivitySportItem";

const PREFIX = "SportRecordModule";

interface IProps {
  applyTime: string;
  route_list: IRouteListItem[];
  actId: number;
}

class ClubActivitySportRecord extends React.Component<IProps, {}> {
  render() {
    const {route_list, actId, applyTime} = this.props;
    const url = `https://www.codoon.com/activity/v2/officialgoal-sportlist/index.html?actId=${actId}`;
    return (
      <div className={PREFIX}>
        <div className={`${PREFIX}-title`}>·挑战运动记录·</div>
        <div style={styles.ruleTime}>我的报名时间：{applyTime.substr(applyTime.indexOf('-') + 1)}</div>
        {route_list &&
        route_list.map((item: IRouteListItem, index) => {
          return <ClubActivitySportItem sport={item} key={index}/>;
        })}
        <a className={`${PREFIX}-moreBtn`} href={url} target="_blank">
          查看更多
        </a>
      </div>
    );
  }
}

export default ClubActivitySportRecord;
